/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInr = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 4V2H4v2h8c.843 0 1.653.393 2.22 1.027.274.305.474.657.605 1.033H4V8h11c-.437 1.18-1.637 2-3 2H3v2l9.263 10 1.474-1.372L6 12h6c2.462 0 4.521-1.69 5-4h3V6.06h-3.13a5.077 5.077 0 0 0-.904-2.03z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgInr as Inr };
